import React from 'react';
import { gapRows } from '../../data/strategy';
import { GapChart } from '../deck/GapChart';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
export function GapSlide() {
  return <SlideFrame marker="Step 04 — The gap" data-id="element-105" data-mp="1554446j5jhpx">
      <SlideTitle sub="Subtract perception from fact, criterion by criterion, then weight by how much each criterion decides. Three real gaps, one of them on the criterion that matters most." data-id="element-106" data-mp="1541ahqug316b">
        The gap, quantified
      </SlideTitle>

      <div className="mt-[3vh] flex min-h-0 flex-1 flex-col pb-[0.5vh]" data-id="element-107" data-mp="7h2d1dvxhp7d">
        <GapChart rows={gapRows} data-id="element-108" data-mp="7ix1h26erzg7" />
      </div>

      <p className="mt-[2vh] shrink-0 text-[clamp(10px,1.15vw,19px)] leading-[1.45] text-ink-soft" data-id="element-109" data-mp="mecxvdugo7fr">
        <span className="font-semibold text-ink" data-id="element-110" data-mp="heqj2zyzij4u">Read:</span> safety is already
        understood, so there is nothing to win there. Efficacy, speed and
        patient experience are worth a full point each — and together they carry
        two-thirds of the decision.
      </p>
    </SlideFrame>;
}